<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-alert v-model="showAlert" variant="danger" dismissible>
                  Login credentials are incorrect!
                </b-alert>
                <b-form
                  name="loginform"
                  @submit.prevent="userlogin('loginform')"
                  data-vv-scope="loginform"
                  style="text-align: center;"
                  v-if="block_status == false"
                >
                  <img
                    src="../assets/images/fc_logo.png"
                    style="text-align: center;"
                  />
                  <!-- <h1 style="text-align: center;">&nbsp;</h1> -->
                  <p style="color: red; " class="p-2">Please login with CAMS credentials</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text
                        ><i class="icon-user"></i></b-input-group-text
                    ></b-input-group-prepend>
                    <b-form-input
                      type="text"
                      id="name"
                      class="form-control"
                      placeholder="Username"
                      v-model="vendor_email"
                      v-validate="'required|email|min:6'"
                      :class="{
                        input: true,
                        'text-danger': errors.has('loginform.email'),
                      }"
                    />
                  </b-input-group>
                  <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                      <i class="fa fa-warning" v-show="errors.has('email')"></i>
                    </span>
                    <span
                      v-show="errors.has('loginform.email')"
                      id="emailmsgtxt"
                      class="help text-danger"
                      >{{ errors.first("loginform.email") }}
                    </span>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend
                      ><b-input-group-text
                        ><i class="icon-lock"></i></b-input-group-text
                    ></b-input-group-prepend>
                    <b-form-input
                      type="password"
                      id="password"
                      name="password"
                      class="form-control"
                      v-model="vendor_password"
                      placeholder="Password"
                      :class="{
                        input: true,
                        'text-danger': errors.has('loginform.password'),
                      }"
                      autocomplete="current-password"
                    />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <span class="icon has-text-warning">
                      <i
                        class="fa fa-warning"
                        v-show="errors.has('password')"
                      ></i>
                    </span>
                    <span
                      v-show="errors.has('loginform.password')"
                      id="passwmsgtxt"
                      class="help text-danger"
                      >{{ errors.first("loginform.password") }}</span
                    >
                  </b-input-group>
                  <!-- captcha code
                   style="width:100%; height:50px" -->
                  <!-- <b-input-group class="mb-4"> -->
                  <b-input-group class="mb-4">
                    <b-input-group-prepend
                      ><b-input-group-text
                        ><i
                          class="fa fa-shield"
                          aria-hidden="true"
                        ></i></b-input-group-text
                    ></b-input-group-prepend>
                    <b-form-input
                      class="form-control"
                      type="text"
                      name="text"
                      id="text"
                      placeholder="Captcha"
                      v-model="text"
                      style=" padding: 6px 12px;"
                      v-validate="'required|min:4'"
                      :class="{
                        input: true,
                        'text-danger': errors.has('loginform.text'),
                      }"
                      @change="checkcaptcha"
                    />
                  </b-input-group>
                  <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                      <i class="fa fa-warning" v-show="errors.has('text')"></i>
                    </span>
                    <span
                      v-show="errors.has('loginform.text')"
                      id="text"
                      class="help text-danger"
                      >{{ errors.first("loginform.text") }}
                    </span>
                  </b-input-group>
                  <b-alert v-model="capAlert" variant="danger" dismissible>
                    Invalid Captcha!
                  </b-alert>

                  <!-- </b-input-group> -->
                  <b-input-group class="mb-4 d-flex flex-flow">
                    <captcha-code
                      :captcha.sync="code"
                      @on-change="handleChange"
                      ref="captcha"
                      style="width: 205px; height: 50px; display:none;"
                    ></captcha-code>
                    <div class="captcha-area">
                      <span class="captcha">{{ code }}</span>
                    </div>
                    <i
                      class="fa fa-refresh"
                      aria-hidden="true"
                      @click="handleClick"
                      style="font-size: 30px;
                                margin-top: 10px;
                                margin-left: 12px;
                                color: #24a0ed;"
                    ></i>
                    <!--  <div>
                           <input style="width:90%; height:30px;margin:5px 0" type="text" name="text" id="text" v-model="text" > &nbsp; 
                        </div> -->
                    <!-- <b-input-group class="mb-4">
                        <b-form-input  type="text" name="text" id="text" v-model="text" />
                      </b-input-group>
 -->
                    <!-- <div>
                      <b-button :disabled="!isActive" @click="submitClick"  >submit</b-button>&nbsp;
                      &nbsp;
                      &nbsp;
                      <b-button @click="resetInput" >Reset</b-button>
                      </div> -->
                  </b-input-group>
                  <b-row>
                    <b-col cols="12">
                      <b-button
                        type="submit"
                        variant="primary"
                        class="px-4"
                        block
                        >Login</b-button
                      >
                    </b-col>
                    <b-col cols="6" class="text-right"> </b-col>
                  </b-row>
                </b-form>
                <!-- Form For Select Brand Start -->
                <b-form
                  name="brandselectform"
                  @submit.prevent="brandselect('selected_reln_id')"
                  data-vv-scope="brandselectform"
                  style="text-align: center;"
                  v-if="block_status == true"
                >
                  <img
                    src="../assets/images/fc_logo.png"
                    style="text-align: center;"
                  />
                  <h1 style="text-align: center;">&nbsp;</h1>

                  <label style="float: left;">Select Brand</label>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text
                        ><i
                          class="fa fa-cart-plus"
                          aria-hidden="true"
                        ></i></b-input-group-text
                    ></b-input-group-prepend>
                    <!-- <b-form-input type="text" id="name" class="form-control" placeholder="Username"  v-model="vendor_email"  v-validate="'required|email|min:6'" :class="{'input': true, 'text-danger': errors.has('loginform.email') }" />
                  </b-input-group> -->
                    <!-- {{brand_list.}} -->
                    <b-form-select
                      id="selected_reln_id"
                      class="form-control"
                      name="selected_reln_id"
                      placeholder="Please Select Brand."
                      v-validate="'required'"
                      @change="storeSelectedBrandId(selected_reln_id)"
                      v-model="selected_reln_id"
                      :class="{
                        input: true,
                        'text-danger': errors.has(
                          'brandselectform.selected_reln_id'
                        ),
                      }"
                    >
                      <option :value="selected">--Select--</option>
                      <option
                        :value="brand_list.reln_id"
                        v-for="brand_list in brand_item"
                        >{{ brand_list.brand_title }} &nbsp;<span
                          v-if="
                            user_type != 'Brand_Manager' &&
                              user_type != 'Quality_Controller' &&
                              user_type != 'Quality_Executive'
                          "
                          >({{ brand_list.brand_manager }})</span
                        ></option
                      >
                    </b-form-select></b-input-group
                  >
                  <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                      <i
                        class="fa fa-warning"
                        v-show="errors.has('selected_reln_id')"
                      ></i>
                    </span>
                    <span
                      v-show="errors.has('brandselectform.selected_reln_id')"
                      id="emailmsgtxt"
                      class="help text-danger"
                      >{{ errors.first("brandselectform.selected_reln_id") }}
                    </span>
                  </b-input-group>
                  <b-row>
                    <b-col cols="12">
                      <b-button
                        type="submit"
                        variant="primary"
                        class="px-4"
                        block
                        >Submit</b-button
                      >
                    </b-col>
                    <b-col cols="6" class="text-right"> </b-col>
                  </b-row>
                </b-form>
                <!-- Form For Select Brand Ends -->
              </b-card-body>
            </b-card>
            <!-- bg-primary -->
            <b-card
              no-body
              class="text-white  py-5 d-md-down-none"
              style="width:156px; background-color: #1976D2"
            >
              <b-card-body class="text-center">
                <img
                  style="font-size: 20px;height: 250px;width: 250px;margin-top: 30% !important;"
                  class="img-avatar"
                  src="../assets/images/FC1.png"
                  alt="admin@bootstrapmaster.com"
                />
              </b-card-body>
            </b-card>
          </b-card-group>

          <!-- Code For Select Brand -->
          <!-- <b-modal id="selectbrandmodel" size="md" title="Select Brand" v-model="selectbrandmodel" @ok="selectbrandmodel = false">
                <form >
                      <div style="height: 100px;">
                      
                          <div  class='col-md-12' > 
                            <label for="name">Select Brand</label>

                            <select class="form-control" id="collection_title" name="collection_title" v-validate="'required|'" >
                                <option value=0>Select Brand</option>
                                <option :value="brand_list.brand_id" v-for="brand_list in brand_item">{{brand_list.brand_title}}
                                </option>

                            </select> 

                          </div>
                        </div>
                      <div class="col-md-12 mb-4 text-center" >
                          <button type='button'   @click="selectbrandfunction()"  class="btn btn-success submit_btn invoice-save-bottom"  style="float: right;">
                              <i class="fa fa-save"></i>
                              Assign Brand Manager
                          </button>
                      </div>    
                </form>  
            </b-modal> -->

          <!-- Code For Select Brand Ends -->
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import auth from "@/utils/auth";
import Vue from "vue";
import CaptchaCode from "vue-captcha-code";
const axios = require("axios");

export default {
  name: "login",
  components: {
    CaptchaCode,
  },
  data() {
    return {
      vendor_email: "",
      vendor_password: "",
      loginModal: false,
      vendor_name: "",
      vendor_id: "",
      json: null,
      flag: false,
      showAlert: false,
      selectbrandmodel: false,
      selected_brand: "",
      selected_user_id: 0,
      brand_item: [],
      block_status: false,
      selected: "",
      result: [],
      sub_cat_data: [],
      selected_brand_id: 0,
      brand_assign: 0,
      selected_user_type: "",
      selected_rel_id: 0,
      selected_reln_id: 0,
      access_token: "",
      assign_token: "",
      capAlert: false,
      code: "",
      text: "",
      user_type:'',
      camsToken:''
    };
  },
  created() {
    var userData = localStorage.getItem("userData");
    var userInfo = JSON.parse(userData);
    this.user_type = userInfo[0].user_type;
    if (userInfo != "") {
      this.flag = false;
      if (auth.loggedIn()) {
        this.$router.push("login").catch(() => {});
      } else {
        // this.$router.push("design_dashboard").catch(() => {});

        if (this.user_type == "Quality_Head") {
            this.$router.push("/dashboard_quality").catch(() => {});
          } else if (this.user_type == "Design_Head") {
            this.$router.push("/dashboard_designhead").catch(() => {});
          } else if (this.user_type == "Buyer" || this.user_type == "Junior_Buyer" ) {
            this.$router.push("/dashboard_buyer").catch(() => {});
          } else if (this.user_type == "Quality_Controller") {
            this.$router.push("/dashboard_quality").catch(() => {});
          } else if (this.user_type == "Quality_Executive") {
            this.$router
              .push("/dashboard_quality_executive")
              .catch(() => {});
          } else if (this.user_type == "Fit_Technician") {
            this.$router.push("/dashboard_fit_tech").catch(() => {});
          } else if (this.user_type == "Brand_Designer") {
            this.$router.push("/dashboard_designer").catch(() => {});
          } else if (this.user_type == "Graphics_Designer") {
            this.$router.push("/graphics_designer").catch(() => {});
          } 
          else if (this.user_type == "Brand_Manager") {
            this.$router.push("/dashboard_brand_manager").catch(() => {});
          } 
          else if (this.user_type == "Admin") {
            this.$router.push("/dashboard_admin_brand").catch(() => {});
          } 



      }
    } else {
      this.$router.push("login").catch(() => {});
    }
  },
  methods: {
    /*
      Function : storeSelectedBrandId 
      Description : Selected value from subCategory and store into localStorage..!
      Created By : Adarsh S. Bhutada
    */
   
    storeSelectedBrandId(selected_reln_id) {
      let obj = this.brand_item.find(o => o.reln_id === this.selected_reln_id);
      console.log("111111111111111111111111111111------------------->",obj);
      localStorage.setItem('selectedBrandId',JSON.stringify({target:{value:obj.brand_id+"+"+obj.brand_title}}));
    },
  
    handleClick() {
      this.$refs.captcha.refreshCaptcha();
    },

    getrelationid(value) {
      // alert(value);
      this.selected_rel_id = value;
    },

    // Code For Select Brand
    /****** Function to Vendor Login ********/
    brandselect(scope) {
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      // document.getElementById("overlay").style.display = "block";
      this.$validator.validateAll(scope).then((result) => {
        var userData = [];
        this.selected_user_type = userInfo[0].user_type;
        if (result) {
          // if(this.selected_user_type!='Brand_Manager'){
          //   this.selected_user_id= userInfo[0].brand_manager;
          // }
          // else{
          //    this.selected_user_id=userInfo[0].user_id;
          // }
          this.isBusy = true;
          const Obj = {
            user_id: userInfo[0].user_id,
            reln_id: this.selected_reln_id,
          };
          axios
            .post(`${CONSTANTS.API_URL}/getAssignedSubCategory`, Obj)
            .then((response) => {
              this.result = response.data;
              if (this.result.returnmsg === "Successful") {
                // localStorage.setItem('userData', '')
                this.sub_cat_data = this.result.returnvalue;
                console.log(
                  "PPPPPPPPPPPPPPPPP111",
                  this.sub_cat_data[0].brand_assign
                );
                var userData1 = this.result.returnvalue;
                // userData= JSON.stringify(userData);
                // var userInfo = JSON.parse(userData);
                // this.user_type = userInfo[0].user_type;
                this.adminuser = userData1[0].full_name;
                this.user_type = userData1[0].user_type;
                this.sub_cat_data[0].camsToken = this.camsToken;

                localStorage.setItem(
                  "userData",
                  JSON.stringify(this.sub_cat_data)
                );
                // var userData = localStorage.getItem('userData')
                // userData.push(userData1);
                // localStorage.setItem('userData', JSON.stringify(userData));

                // localStorage.setItem('brand_title', JSON.stringify(this.sub_cat_data[0].brand_title));
                // localStorage.setItem('reln_id', JSON.stringify(this.sub_cat_data[0].reln_id));
                // localStorage.setItem('role', JSON.stringify(this.sub_cat_data[0].role));
                // localStorage.setItem('is_dh_available', JSON.stringify(this.sub_cat_data[0].is_dh_available));
                // localStorage.setItem('designation', JSON.stringify(this.sub_cat_data[0].designation));
                // localStorage.setItem('subcat_assign', JSON.stringify(this.sub_cat_data[0].subcat_assign));

                // localStorage.setItem('userData', JSON.stringify(userData))
                // var userData1 = localStorage.getItem('userData')
                // var userInfo = JSON.parse(userData);
                // this.user_type = userInfo[0].user_type;
                // localStorage.setItem('userData', JSON.stringify(userData1))
                // console.log("OOOOOOOOOOOPPPPPPPPPPPOOOOOOOOOOO",userData1[0].token)
                // var userData = localStorage.getItem('userData')
                // var userInfo = JSON.parse(userData);
                // this.user_type = userInfo[0].user_type;
                // var d1 = new Date()
                // localStorage.setItem('activeTime', d1.getMinutes())

                // axios.defaults.headers.common['x-access-token']  = userData1[0].token;

                if (this.user_type == "Quality_Head") {
                  this.$router.push("/dashboard_quality").catch(() => {});
                } else if (this.user_type == "Design_Head") {
                  this.$router.push("/dashboard_designhead").catch(() => {});
                } else if (this.user_type == "Buyer" || this.user_type == "Junior_Buyer" ) {
                  this.$router.push("/dashboard_buyer").catch(() => {});
                } else if (this.user_type == "Quality_Controller") {
                  this.$router.push("/dashboard_quality").catch(() => {});
                } else if (this.user_type == "Quality_Executive") {
                  this.$router
                    .push("/dashboard_quality_executive")
                    .catch(() => {});
                } else if (this.user_type == "Fit_Technician") {
                  this.$router.push("/dashboard_fit_tech").catch(() => {});
                } else if (this.user_type == "Brand_Designer") {
                  this.$router.push("/dashboard_designer").catch(() => {});
                } else if (this.user_type == "Graphics_Designer") {
                  this.$router.push("/graphics_designer").catch(() => {});
                } else {
                  // this.block_status=true;
                  // this.selectbrandmodel= !this.selectbrandmodel;

                  if (
                    this.selected_reln_id == "" ||
                    this.selected_reln_id == undefined
                  ) {
                    // alert("Please Select Atleast One Brand");
                    this.$fire({
                      text: "Please Select Atleast One Brand.",
                      type: "warning",
                      timer: 30000,
                    });
                    this.selectbrandmodel = !this.selectbrandmodel;
                  } else {
                    if(this.user_type == "Buying_Head"){
                      this.$router.push("/dashboard_buyingHead").catch(() => {});
                    }else{
                       this.$router.push("/dashboard_brand_manager").catch(() => {});
                    }                  
                  }
                }
                // this.$router.push('/dashboard_brand_manager');
                this.totalRows = this.result.returnvalue.length;
                this.isBusy = !this.isBusy;
              } else {
                this.sub_cat_data = [];
                this.totalRows = 0;
                this.isBusy = !this.isBusy;
              }
            })
            .catch((e) => {
              this.errors.push(e);
            });
        }
      });
    },

    // Code for Captcha
    checkcaptcha() {
      if (this.text === this.code) {
        this.capAlert = false;
      } else {
        this.capAlert = true;
      }
    },

    //Code For Select Brand

    selectbrandfunction: function() {
      //alert("In");
    },

    // Code For Select Brand Ends

    /****** Function to Vendor Login ********/
    userlogin(scope) {     
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          if (this.text !== "") {
            if (this.text === this.code) {
              const loginObj = {
                sysemailid: this.vendor_email,
                syspassword: this.vendor_password,
              };

              if (this.quantity !== "") {
                axios
                  .post(
                    `${CONSTANTS.API_URL}/validatecamssystemuserlogin`,
                    loginObj
                  )
                  .then((response) => {
                    if (response.data.returnmsg == "successful") {
                      var userData1 = response.data.returnvalue;
                      // userData= JSON.stringify(userData);
                      console.log('userData1!!!!!!!!!!!!!!!!',userData1);
                      this.adminuser = userData1[0].full_name;
                      this.user_type = userData1[0].user_type;
                      this.camsToken = userData1[0].camsToken;
                      console.log('this.camsToken',this.camsToken);
                      localStorage.setItem(
                        "userData",
                        JSON.stringify(userData1)
                      );
                      console.log(
                        "OOOOOOOOOOOPPPPPPPPPPPOOOOOOOOOOO",
                        userData1[0].token
                      );
                      var userData = localStorage.getItem("userData");
                      var userInfo = JSON.parse(userData);
                      this.user_type = userInfo[0].user_type;
                      // localStorage.setItem('Coduser', "codvaliduser")
                      var d1 = new Date();
                      localStorage.setItem("activeTime", d1.getMinutes());

                      axios.defaults.headers.common["x-access-token"] =
                        userData1[0].token;
                    
                      //  console.log(this.$http.headers.common['x-access-token']);
                      //console.log(this.$http);
                      //alert(userData.defaultpage)

                      // if(userData.defaultpage)
                      // {
                      //   this.$router.push(userData.defaultpage).catch(()=>{});
                      // }
                      // else if (userData.defaultpage == null )
                      // {
                      //    alert("Access rights not set.Please contact admin.");
                      // }

                      if (this.user_type == "Admin") {
                        this.$router
                          .push("/dashboard_admin_brand")
                          .catch(() => {});
                      } else if (this.user_type == "Quality_Controller") {
                        this.$router.push("/dashboard_quality").catch(() => {});
                      } else if (this.user_type == "Graphics_Designer") {
                        this.$router.push("/graphics_designer").catch(() => {});
                      }else if (this.user_type == "Planner_Admin") {
                        this.$router.push("/mccreport").catch(() => {});
                      }else if (this.user_type == "Planner") {
                        this.$router.push("/mccreport").catch(() => {});
                      }


                      // else if(this.user_type=='Quality_Controller')
                      // {

                      //   this.$router.push('/dashboard_quality').catch(()=>{});
                      // }
                      else {
                        this.block_status = true;
                        this.selectbrandmodel = !this.selectbrandmodel;
                        this.getselecteduserbrand();
                      }

                      // if(this.user_type=='Quality_Head'){
                      //   this.$router.push('/dashboard').catch(()=>{});
                      // }

                      //window.location.href ="/design_dashboard";
                    } else {
                      // alert("Invalid login details");
                      this.$fire({
                        text: "Invalid login details",
                        type: "error",
                        timer: 30000,
                      });
                      if (result.body.returnmsg === "NoUserExists") {
                        // alert("Invalid login details provided.");
                        this.$fire({
                          text: "Invalid login details provided.",
                          type: "error",
                          timer: 30000,
                        });
                        // this.showAlert=true
                      }
                    }
                  });
              }
            } //captcha check closing
            else {
              if (this.text !== this.code) {
                this.capAlert = true;
              }
            }
          } //captcha Text closing
        } //result closing
      }); //validation closing
    },

    //Code For Select Brand
    getselecteduserbrand: function(value) {
      this.isBusy = true;
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      const Obj = {
        user_id: userInfo[0].user_id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getAllocateddBrandList`, Obj)
        .then((response) => {
          // document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.brand_item = this.result.returnvalue;
            console.log("PPPPPPPPPPPPPPPPPP", this.brand_item);
            this.totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
          } else {
            this.brand_item = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    //Code Ends For Select Brand

    fetchCompanyInfo: function() {},
    toggleInfoModal: function() {
      this.toggleInfo = !this.toggleInfo;
    },
  },
};
</script>
<style>
.captcha-area .captcha {
  font-size: 28px;
  letter-spacing: 20px;
  margin-left: 10px;
}

.captcha-area {
  width: 180px;
  margin-left: 5px;
}
</style>
